/**
 * react-query retry policy for the marketplace (M3 QA item 6).
 *
 * The library default (3 retries with backoff) made a real 404 salon take
 * ~7.6 s to show "not found". A 4xx is an answer, not a glitch: never retry
 * it. A 5xx or a network failure (no status) gets ONE retry.
 */
export const MAX_SERVER_RETRIES = 1;

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  const status = (error as { status?: unknown } | null)?.status;
  if (typeof status === 'number' && status >= 400 && status < 500) return false;
  return failureCount < MAX_SERVER_RETRIES;
}
